import axios from "../../../../../../api/axiosInstance";
import {
  UpdateProductStoreCategoryRequest,
  UpdateProductStoreCategoryResponse,
} from "./types";

export const updateProductStoreCategory = async (
  id: string,
  data: UpdateProductStoreCategoryRequest,
): Promise<UpdateProductStoreCategoryResponse> => {
  const response = await axios.put<UpdateProductStoreCategoryResponse>(
    `/api/private/product-store/categories/${id}`,
    data,
  );
  return response.data;
};
